import r from "react";
import { translate as e } from "@aws-amplify/ui";
import { View as i } from "../../../primitives/View/View.js";
import { Text as t } from "../../../primitives/Text/Text.js";
var o = function o(_ref) {
  var o = _ref.errors,
    m = _ref.id;
  return (null == o ? void 0 : o.length) > 0 ? r.createElement(i, {
    "data-amplify-sign-up-errors": !0,
    id: m
  }, o.map(function (i) {
    return r.createElement(t, {
      key: i,
      role: "alert",
      variation: "error"
    }, e(i));
  })) : null;
};
export { o as ValidationErrors };